import React from "react"
import CheckBagde from "images/check-badge-icon.svg"
import styled from "styled-components"
import CloudinaryImage from "components/cloudinary-image"
import RichTextContentful from "components/rich-text"
import {
  CardImage,
  Image,
  CardOverlay,
  ContentWrapper,
  NameWrapper,
  Name,
  Credentials,
  Role,
  Badge,
  Card,
} from "./styles"

const PersonNestedCard = ({
  name,
  link,
  description,
  imageUrl,
  dataId,
  credentials,
  shortBio,
  hideIdentity,
  title,
  ...props
}) => {
  const [mainName, credentialsFromName] = name.split(/,(.*)/s).filter(Boolean)

  const renderContent = () => (
    <>
      <CardImage>
        <Image
          baseUrl={imageUrl}
          alt={name}
          images={[
            {
              transforms: "c_fill,g_face,w_270,h_405,q_90,f_auto,fl_lossy",
            },
            {
              screensize: 768,
              transforms: "c_fill,g_face,w_230,h_360,q_90,f_auto,fl_lossy",
            },
          ]}
          lazy
        />
      </CardImage>

      <CardOverlay>
        <ContentWrapper>
          <NameWrapper>
            <Name>{mainName}</Name>
            {credentialsFromName && <Credentials>{credentialsFromName}</Credentials>}
          </NameWrapper>
          <Role>{credentials}</Role>
          {shortBio?.raw && <RichTextContentful rawRichText={shortBio.raw} isWhiteText />}
        </ContentWrapper>
        <Badge>
          <img src={CheckBagde} alt="check-badge" />
          <span>{title}</span>
        </Badge>
      </CardOverlay>
    </>
  )

  return (
    <Card data-exp-id={dataId} {...props}>
      {link ? <a href={link}>{renderContent()}</a> : renderContent()}
    </Card>
  )
}

export default PersonNestedCard
